"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    theme: _propTypes.string,
    content: (0, _propTypes.shape)({
      primary: _propTypes.string,
      secondary: _propTypes.string
    }),
    onClick: _propTypes.func,
    onEdit: _propTypes.func,
    prefix: _propTypes.string,
    placeholder: _propTypes.string,
    type: (0, _propTypes.oneOf)(_constant2.Types),
    translation: (0, _propTypes.shape)({
      edit: _propTypes.string
    })
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    content: {},
    onClick: function onClick() {},
    onEdit: function onEdit() {},
    placeholder: '',
    type: 'default',
    translation: {
      edit: 'Edit'
    }
  }
};
exports.default = _default;